// src/pages/TermsOfService.js
import React, { useEffect, useState } from "react";
import { Box, Heading, Spinner } from "@chakra-ui/react";
import ReactMarkdown from "react-markdown";

export default function TermsOfService() {
    const [md, setMd] = useState(null);

    useEffect(() => {
        fetch("/justify_terms.md")
            .then((res) => {
                if (!res.ok) throw new Error("Could not load Terms of Service");
                return res.text();
            })
            .then(setMd)
            .catch((err) => {
                console.error(err);
                setMd("# Error\nUnable to load terms of service.");
            });
    }, []);

    if (md === null) {
        return (
            <Box textAlign="center" py={10}>
                <Spinner size="xl" />
            </Box>
        );
    }

    return (
        <Box p={8} maxW="800px" mx="auto">
            <Heading mb={6}>Terms of Service</Heading>
            <Box className="tos-content" sx={{
                // optional styling
                "h2, h3": { mt: 4, mb: 2 },
                p: { mb: 3, lineHeight: 1.6 },
            }}>
                <ReactMarkdown>{md}</ReactMarkdown>
            </Box>
        </Box>
    );
}
